import {
  useState,
  createContext,
  useContext,
  useMemo,
  useCallback
} from 'react';

const DrawerContext = createContext();

export const useDrawerState = () => useContext(DrawerContext);

export const DrawerProvider = ({ children }) => {
  const [drawerState, setDrawerState] = useState(false);
  const toggleDrawer = useCallback(() => {
    setDrawerState(!drawerState);
  }, [drawerState, setDrawerState]);
  const val = useMemo(() => ({
    drawerState,
    toggleDrawer
  }), [drawerState, toggleDrawer]);

  return (
    <DrawerContext.Provider value={val}>
      { children }
    </DrawerContext.Provider>
  );
};
